import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Avatar from 'flarum/common/components/Avatar';
/**
 * Shown after a user's forum account is linked to an OAuth provider for the
 * first time — both via the security-page manual link flow and the automatic
 * email-match link that happens during login.
 */
export default class AccountLinkedModal extends Modal {
  className() {
    return 'Modal--small AccountLinkedModal';
  }
  title() {
    return app.translator.trans('fof-oauth.forum.account_linked.title');
  }
  content() {
    const user = app.session.user;
    const providerKey = this.attrs.provider;
    const providerName = app.translator.trans(`fof-oauth.forum.providers.${providerKey}`);
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "AccountLinkedModal-user",
      style: "text-align: center; margin-bottom: 1rem;"
    }, m(Avatar, {
      user: user,
      style: "display: block; margin: 0 auto 0.5rem;"
    }), m("span", {
      className: "AccountLinkedModal-username",
      style: "display: block; font-weight: bold;"
    }, user.displayName())), m("p", {
      className: "AccountLinkedModal-body"
    }, app.translator.trans('fof-oauth.forum.account_linked.body', {
      forum: app.forum.attribute('title'),
      username: user.displayName(),
      provider: providerName
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.hide()
    }, app.translator.trans('fof-oauth.forum.account_linked.dismiss_button'))));
  }
}
flarum.reg.add('fof-oauth', 'forum/components/AccountLinkedModal', AccountLinkedModal);